export default __webpack_public_path__ + "static/media/Dashboard.808634cc.png";